module.exports = __webpack_public_path__ + "img/inspire-logo1.13bf2301.png";